export default {
  text: 'Drag the file here, or <em>click to upload</em>',
}
